export const tagging = {
  taggingId: {
    type: String,
    required: true,
  },
};

const ALLOWED_RESOLUTIONS = ['sm', 'md'];
const validateResolution = (value) => {
  if (!value?.md) return false;

  return Object.entries(value).every(
    ([resolution, src]) =>
      ALLOWED_RESOLUTIONS.includes(resolution) && src && typeof src === 'string',
  );
};

export const common = {
  caption: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  headingLevel: {
    type: String,
    default: 'h2',
    validator(value) {
      return ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(value);
    },
  },
  description: {
    type: String,
    default: '',
  },
  cta: {
    type: Object,
    default: () => ({}),
  },
  image: {
    type: Object,
    required: true,
    validator: validateResolution,
  },
  imageAlt: {
    type: String,
    default: 'Product with interactive hotspots',
  },
  markerBorderColor: {
    type: String,
    default: undefined,
  },
  markerFillColor: {
    type: String,
    default: undefined,
  },
  markerButtonAccessibleLabel: {
    type: String,
    default: 'Additional information concerning this product',
  },
  modalCloseButtonAccessibleLabel: {
    type: String,
    default: 'Close dialog',
  },
  pois: {
    type: Array,
    default: () => [],
  },
};
